import React from 'react'

const WPGPullquoteBlock = props => {
  const {
    // attrs,
    // innerBlocks,
    innerHTML,
  } = props

  return (
    <div
      className="wp-block block--pullquote"
      dangerouslySetInnerHTML={{ __html: innerHTML }}
    />
  )
}

export default WPGPullquoteBlock
